import { render, staticRenderFns } from "./add-report.vue?vue&type=template&id=29d60b59&scoped=true"
import script from "./add-report.vue?vue&type=script&lang=ts"
export * from "./add-report.vue?vue&type=script&lang=ts"
import style0 from "./add-report.vue?vue&type=style&index=0&id=29d60b59&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d60b59",
  null
  
)

export default component.exports